/** @format */
import { FudisSelectOption } from '@funidata/ngx-fudis';
import { CourseUnit, CustomStudyDraft, StudyPeriodLocator } from 'common-typescript/types';

interface Study {
    value: CourseUnit | CustomStudyDraft;
    type: 'CourseUnit' | 'CustomStudyDraft';
    plannedPeriods: StudyPeriodLocator[];
}

export type SelectableStudy = FudisSelectOption<Study>;

export interface MultiselectGroup {
    id: string;
    label: string;
    options: SelectableStudy[];
}

export interface StudySelectGroup {
    id: string;
    label: string;
    options: SelectableStudy[];
}

/** Contains groups of selectable studies under an education phase (top-level module, e.g. a degree programme) */
export interface EducationPhaseStudies {
    id: string;
    label: string;
    optionGroups: MultiselectGroup[];
}

export function isSelectableCourseUnit(study: SelectableStudy) {
    return study?.value.type === 'CourseUnit';
}

export function isSelectableCustomStudyDraft(study: SelectableStudy) {
    return study?.value.type === 'CustomStudyDraft';
}
